import { type ReactElement } from 'react';
import { Link } from 'react-router';
import { Check } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useTranslation } from '@/lib/i18n';

// The confirmation of the mockup: a tick, the code, and where the mail went.
export function BookedPanel({
  slug,
  code,
  email,
  onClose,
}: {
  slug: string;
  code: string;
  email: string;
  onClose: () => void;
}): ReactElement {
  const { t } = useTranslation();

  return (
    <>
      <span aria-hidden className="fixed inset-0 z-70 bg-black/40" />
      <div
        role="dialog"
        aria-label={t('successTitle')}
        className="fixed inset-x-4 top-1/2 z-80 mx-auto flex max-w-[400px] -translate-y-1/2 flex-col items-center gap-3 rounded-2xl border bg-card p-6 text-center shadow-2xl"
      >
        <span className="grid size-12 place-items-center rounded-full bg-emerald-100 text-emerald-700">
          <Check className="size-6" strokeWidth={3.4} aria-hidden />
        </span>
        <h3 className="text-[17px] font-extrabold">{t('successTitle')}</h3>
        <p className="text-[13px] text-muted-foreground">
          {t('successMsg')} <b className="text-foreground">{email}</b>
        </p>
        <b
          data-testid="booking-code"
          className="rounded-xl border-2 border-dashed px-4 py-2 text-lg font-extrabold tracking-[0.15em]"
        >
          {code}
        </b>
        <p className="text-[12px] text-muted-foreground">{t('showAtVenue')}</p>
        <div className="mt-1 flex w-full gap-2">
          <Button variant="outline" className="flex-1" onClick={onClose}>
            {t('close')}
          </Button>
          <Button asChild className="flex-1">
            <Link to={`/${slug}/booking?code=${encodeURIComponent(code)}`}>
              {t('manageBooking')}
            </Link>
          </Button>
        </div>
      </div>
    </>
  );
}
